
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./RecipeSlider.css";


import biryani from "../../assets/biryani.jpg";
import cake from "../../assets/cake.jpg";
import chinese from "../../assets/chinese.jpg";
import cholebhature from "../../assets/cholebhature.jpg";
import coffee from "../../assets/coffee.jpg";
import desserts from "../../assets/desserts.jpg";
import khichdi from "../../assets/khichdi.jpg";
import lassi from "../../assets/lassi.jpg";
import noodles from "../../assets/noodles.jpg";
import northindian1 from "../../assets/northindian1.jpg";
import paratha from "../../assets/paratha.jpg";
import poori1 from "../../assets/poori1.jpg";
import pureveg from "../../assets/pureveg.jpg";
import salad from "../../assets/salad.jpg";
import shake from "../../assets/shake.jpg";
import tea from "../../assets/tea.jpg";


const imgSlider = [
  { image: biryani, name: "Biryani" },
  { image: cake, name: "Cake" },
  { image: chinese, name: "Chinese" },
  { image: cholebhature, name: "Cholebhature" },
  { image: coffee, name: "Coffee" },
  { image: desserts, name: "Desserts" },
  { image: khichdi, name: "Khichdi" },
  { image: lassi, name: "Lassi" },
  { image: noodles, name: "Noodles" },
  { image: northindian1, name: "North Indian" },
  { image: paratha, name: "Paratha" },
  { image: poori1, name: "Poori" },
  { image: pureveg, name: "Pure Veg" },
  { image: salad, name: "Salad" },
  { image: shake, name: "Shake" },
  { image: tea, name: "Tea" },
];


const RecipeSlider = () => {
  const settings = {
    
    infinite: true,
    speed: 600,
    slidesToShow: 7,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        // settings: { slidesToShow: 1 },
    settings: { slidesToShow: 3 },
      },
    ],
  };

  return (
    <div className="main-box">
      <Slider {...settings}>
        {imgSlider.map((item, index) => (
          <div key={index} className="card">
            <img src={item.image} alt="img" className="slider-img" />
            <hr />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default RecipeSlider;

